export default __webpack_public_path__ + "static/media/logo_talent.851a461d.svg";